export default __webpack_public_path__ + "static/media/image-tel-desktop.c7375bb5.png";